<template>
    <div
        class="d-flex justify-content-center align-items-center"
        :class="{'w-100': widthFull}"
    >
        <transition name="fade-fast" mode="out-in">
            <span v-if="text || forceShow">{{ text }}</span>
            <div 
                v-else
                class="base-placeholder-text d-inline-block rounded" 
                :class="{'w-100': widthFull}"
                :style="{minWidth: widthMin + 'rem'}"
                v-html="placeholderHtml"
            >
            </div>
        </transition>
    </div>
</template>

<script>

export default {
    name: 'PholderText',
    props: {
        text: {
            type: [String, Number],
            required: false,
        },
        forceShow: {  // set to true to force into loaded state (not loading)
            type: Boolean,
            default: false,
        },
        widthMin: {  // width of placeholder in rem units
            type: [Number, String],
            default: 0,
        },
        widthFull: {  // set to true if you want loader to be full width
            type: Boolean,
            default: false,
        }
    },
    data: function() {
        return {
            placeholderHtml: '&emsp;',
        }
    },
    computed: {
        remWidth: function() {
            return this.widthMin + 'rem';
        }
    },
    methods: {
    }
}
</script>

<style>
.base-placeholder-text {
    background-color: rgba(0,0,0,0.05);
    /*box-shadow: 0 4px 10px 0 rgba(33, 33, 33, 0.15);*/
    height: auto;
    width: auto;
    position: relative;
    overflow: hidden;
}
.base-placeholder-text::before {
    content: '';
    display: block;
    position: absolute;
    left: -150px;
    top: 0;
    height: 100%;
    width: 150px;
    background: linear-gradient(to right, transparent 0%, var(--gray-200) 50%, transparent 100%);
    animation: placeholder-loading 1s cubic-bezier(0.4, 0.0, 0.2, 1);
    animation-iteration-count: infinite;
}
@keyframes placeholder-loading {
    from {
        left: -150px;
    }
    to   {
        left: 100%;
    }
}

</style>